"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Switch$defaultProps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Switch = function Switch(props) {
  var checked = props.checked,
      onChange = props.onChange,
      name = props.name,
      className = props.className,
      label = props.label,
      disabled = props.disabled,
      color = props.color,
      title = props.title,
      size = props.size,
      sizeLabel = props.sizeLabel,
      labelPlacement = props.labelPlacement,
      trueLabel = props.trueLabel,
      falseLabel = props.falseLabel,
      onBlur = props.onBlur;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "form-label switch-title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "toggle-switch ".concat(className, " ").concat(labelPlacement)
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    name: name,
    id: "toggleSwitch",
    checked: checked,
    disabled: disabled,
    onChange: !disabled ? onChange : null
  }), /*#__PURE__*/_react.default.createElement("div", {
    checked: checked,
    className: "toggle-switch-container ".concat(color, " ").concat(checked ? "".concat(disabled ? 'disabled' : color, "-checked") : '', " ").concat(size, "  ").concat(disabled ? 'disabled' : ''),
    onClick: !disabled ? onChange : null,
    tabIndex: "1",
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toggle-ball ".concat(color, " ").concat(size, "  ").concat(disabled ? 'disabled' : '')
  })), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "toggleSwitch",
    className: "switch-label ".concat(sizeLabel)
  }, checked ? trueLabel : falseLabel)));
};

Switch.propTypes = {
  checked: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  name: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  color: _propTypes.default.oneOf(['primary', 'secondary', 'danger', 'primary-secondary']),
  title: _propTypes.default.string,
  labelPlacement: _propTypes.default.oneOf(['right', 'bottom']),
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg']),
  sizeLabel: _propTypes.default.oneOf(['sm', 'md', 'lg']),
  trueLabel: _propTypes.default.string,
  falseLabel: _propTypes.default.string,
  onBlur: _propTypes.default.func
};
Switch.defaultProps = (_Switch$defaultProps = {
  name: '',
  className: '',
  disabled: false,
  color: 'primary',
  title: '',
  labelPlacement: 'right',
  size: 'md',
  sizeLabel: 'lg'
}, _defineProperty(_Switch$defaultProps, "labelPlacement", 'right'), _defineProperty(_Switch$defaultProps, "trueLabel", ''), _defineProperty(_Switch$defaultProps, "falseLabel", ''), _defineProperty(_Switch$defaultProps, "onBlur", function onBlur() {}), _Switch$defaultProps);
var _default = Switch;
exports.default = _default;